import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { ReportAProblemPageComponent } from '../report-a-problem-page/report-a-problem-page.component';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-fdrs-view',
  templateUrl: './fdrs-view.component.html',
  styleUrls: ['./fdrs-view.component.scss']
})
export class FdrsViewComponent implements OnInit, AfterViewChecked {
  public getApiRes: any;
  public language = '';
  public country = '';
  public market = '';
  public invinnumber: any;
  public username: any;
  public userType: any;
  public candidateId = '';
  public candidateKind = '';
  public sessionId: any;
  public previousScreen: string = '';
  public repairObj: any;
  public postRepairObj: any;
  public displayHTML: any = '';
  public showHtmlContainer: boolean = false;
  public gIdRepair: any = [];
  public gIdPostRepair: any = [];
  isEtisCandidate: boolean = false;
  countViewChecked: number = 0;
  viewContent: boolean = false;
  getHTMLData: boolean = false;
  image: any;
  imageUrl: any;
  newPath: any;
  oldPath: any;
  newcontent:boolean = false;
  viewCompleteRepairPostPepair: boolean = false;
  tokenSubscription: Subscription = new Subscription;
  navigatePreviousScreenSubscription: Subscription = new Subscription;
  repairSubscription: Subscription = new Subscription;
  gIdRepairSubscription: Subscription = new Subscription;
  postRepairSubscription: Subscription = new Subscription;
  gIdPostRepairSubscription: Subscription = new Subscription;
  constructor(private service: ApifirstService, private modalService: NgbModal, private router: Router, private translate: TranslateService, private activateRoute: ActivatedRoute,private sanitizer: DomSanitizer,private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.service.isShowRAP.next(false);
    this.sessionId = localStorage.getItem("sessionID");

    this.tokenSubscription = this.service.tokenObj.subscribe((data) => {
      let token: any = data;
      this.country = token.country;
      this.language = token.language;
      this.market = token.marketCountry;
      this.invinnumber = token.vin;
      this.username = token.username;
      this.userType = token.userType;
    })

    this.repairSubscription = this.service.repairObj.subscribe((data) => {
      this.repairObj = data;
    })

    this.postRepairSubscription = this.service.postRepairObj.subscribe((data) => {
      this.postRepairObj = data;
    })

    this.gIdRepairSubscription = this.service.storeGidRepair.subscribe((data) => {
      this.gIdRepair = data;
    })

    this.gIdPostRepairSubscription = this.service.storeGidPostRepair.subscribe((data) => {
      this.gIdPostRepair = data;
    })

    this.navigatePreviousScreenSubscription = this.service.navigatetoPreviousScreen.subscribe((data) => {
      this.manipulatePreviousScreenData(data);
    })

    this.getTableOfView(this.candidateId);
    if (this.previousScreen == 'repair') {
      this.service.getViewDetailsofFDRSAPI(this.candidateId, this.sessionId).subscribe((data) => {
      })
    }
    if (this.previousScreen == 'postRepair') {
      this.service.postRepairTestBtnClick(this.candidateId, this.sessionId).subscribe((data) => {
      })
    }
  }

  ngAfterViewChecked() {
    if(this.displayHTML && this.countViewChecked == 0) {
      this.countViewChecked++;
      const pinpointLinks = document.querySelectorAll("a[href]");
      const buttonLinks = document.querySelectorAll("input[onclick]");
      pinpointLinks.forEach(link => {
        let href: any = link.getAttribute('href');
        let extras: NavigationExtras = {
          relativeTo: this.activateRoute,
          queryParamsHandling: 'merge',
        };
        if(href[0]=='#' || href=='') {
          extras.queryParams = this.activateRoute.snapshot.params;
          if(href[0]=='#'){
            extras.fragment = href.slice(1);
          }
          link.addEventListener('click', ()=>{
            this.router.navigate([],extras);
          });
        }else if(href[0]== 'G' || href[0]=='p') {
          // do nothing
        }else {
          const query: any[] = href.split('?');
          let params = JSON.parse('{"' + decodeURI(query[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
          extras.queryParams = params;
          link.addEventListener('click', ()=>{
            this.service.getViewDetailsofFDRSRedirect(href).subscribe((data)=>{
              this.countViewChecked = 0;
              this.getApiRes = data;
              this.testHtml();
              this.router.navigate([],extras);
            })
          });
        }
        link.setAttribute('href','javascript:void(0)');
      })
      buttonLinks.forEach(link => {
        link.setAttribute('onclick','javascript:void(0)');
      })
      const headers = document.querySelectorAll("th");
      headers.forEach(header => header.setAttribute('style','border-width: 1px'));
      const tableData = document.querySelectorAll("td[valign='top']");
      for(let i=0; i<tableData.length; i++){
        let childNodeLength: number;
        let row: number = i%3;
        if(row == 0){
          childNodeLength = Math.min(tableData[i].childNodes.length,tableData[i+1].childNodes.length,tableData[i+2].childNodes.length);
        }else if(row == 1){
          childNodeLength = Math.min(tableData[i].childNodes.length,tableData[i+1].childNodes.length);
        }else{
          childNodeLength = tableData[i].childNodes.length;
        }
        let style = tableData[i].getAttribute('style');
        if(childNodeLength == 0){
          if(style){
            tableData[i].setAttribute('style',style);
          }
        }else{
          if(style){
            tableData[i].setAttribute('style',tableData[i].getAttribute('style')+' border-width: 1px');
          }else{
            tableData[i].setAttribute('style','border-width: 1px');
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.service.isShowRAP.next(true);
    this.tokenSubscription.unsubscribe();
    this.navigatePreviousScreenSubscription.unsubscribe();
    this.repairSubscription.unsubscribe();
    this.gIdRepairSubscription.unsubscribe();
    this.postRepairSubscription.unsubscribe();
    this.gIdPostRepairSubscription.unsubscribe();
  }

  reportAProblemPopup() {
    if (1 == 1) {
      this.service.sendGnumberToRAP.next(this.candidateId);
      const modalRef = this.modalService.open(ReportAProblemPageComponent, {
        windowClass: "myCustomModalClass",
        backdrop: 'static'
      });
      modalRef.result.then(
        result => {
          console.log(result);
        },
        reason => { }
      );
    }
  }

  manipulatePreviousScreenData(data: any) {
    this.previousScreen = data.screen;
    this.candidateId = data.id;
    this.candidateKind = data.kind;
    if(this.candidateKind == 'ETIS-CANDIDATE') {
      this.showHtmlContainer = false;
      this.isEtisCandidate = true;
    }
  }

  getTableOfView(id: string) {
    let printText: string = this.translate.instant('Print');
    this.service.getViewDetailsofFDRS(id, this.language, this.country, this.market, "SPA", printText,this.username,this.userType).subscribe((data) => {
      this.getApiRes = data;
      if (!this.isEtisCandidate) {
        this.showHtmlContainer = true;
      }
      this.testHtml();
    })
  }

  testHtml() {
    this.viewContent = true;
    if (this.candidateKind == 'TSB-CANDIDATE') {
      this.displayHTML = this.getApiRes.tsbOutPut;
    } else {
      this.displayHTML = this.getApiRes;
    }
    this.extractImgSrc(this.displayHTML);
    if (this.displayHTML) {
      this.getHTMLData = true;
    } else {
      this.getHTMLData = false;
    }
  }

  callGetImage(url:any) {
    this.service.getImage(url).subscribe((res:any) => {
      let objectURL = URL.createObjectURL(res);       
      this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL)
      this.imageUrl = this.image.changingThisBreaksApplicationSecurity;


      this.newPath.push( {
          'oldpath': url,
          'newpath':  this.imageUrl
    });
    if (this.oldPath.length == this.newPath.length) {
      this.newPath.forEach((element:any) => {
        this.displayHTML = this.displayHTML.replaceAll(element.oldpath, element.newpath)
      });
      this.newcontent = true;
      this.spinnerService.hide();
    }
    });
  }


  extractImgSrc(htmlString: string) {
    this.spinnerService.show();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const images = doc.getElementsByTagName('img');
    this.oldPath = [];
    this.newPath = [];
    for (let i = 0; i < images.length; i++) {
      let imgSrc = images[i].src;
      if (imgSrc.startsWith('https')) {
        this.oldPath.push(imgSrc);
        this.callGetImage(imgSrc);
      }
    } 
    if(this.oldPath.length == 0) {
      this.newcontent = true;
      this.displayHTML = htmlString;
      this.spinnerService.hide();
    }
  }

  noFaultPopup() {
    let req: any = {
      "sessionId": this.sessionId,
      "faultFoundValue": "false",
      "faultComponentGNumber": "",
      "vin": this.invinnumber,
      "userId": this.username,
      "userType": this.userType,
      "languageCode": this.language,
      "countryCode": this.country
    }
    if (this.previousScreen === 'postRepair') {
      req["pageState"] = "POST_REPAIR";
      if (!this.getHTMLData) {
        req["faultFoundValue"] = "Error";
      }
      for (let candidate of this.postRepairObj) {
        if (candidate.procRef.procUidRef == this.candidateId) {
          console.log('********', candidate);
          candidate.result.state = 'Viewed';
          if (!this.getHTMLData) {
            candidate.result.state = 'Error';
          }
          break;
        }
      }
      if (!this.gIdPostRepair.includes(this.candidateId)) {
        this.gIdPostRepair.push(this.candidateId);
        this.service.storeGidPostRepair.next(this.gIdPostRepair);
      }
      this.service.postRepairObj.next(this.postRepairObj);
      this.viewCompleteRepairPostPepair = true;
      this.service.noFaultButtonClick(req).subscribe((data) => {
        this.viewCompleteRepairPostPepair = false;
        console.log("No fault Btn Post:", data);
        this.router.navigate(['/postrepairProcedures']);
      })
    } else if (this.previousScreen == 'repair') {
      req["pageState"] = "REPAIR";
      if (!this.getHTMLData) {
        req["faultFoundValue"] = "Error";
      }
      for (let candidate of this.repairObj) {
        if (candidate.procRef.procUidRef == this.candidateId) {
          console.log('********', candidate);
          candidate.result.state = 'Viewed';
          if (!this.getHTMLData) {
            candidate.result.state = 'Error';
          }
          break;
        }
      }
      if (!this.gIdRepair.includes(this.candidateId)) {
        this.gIdRepair.push(this.candidateId);
        this.service.storeGidRepair.next(this.gIdRepair);
      }
      this.service.repairObj.next(this.repairObj);
      this.viewCompleteRepairPostPepair = true;
      this.service.noFaultButtonClick(req).subscribe((data) => {
        this.viewCompleteRepairPostPepair = false;
        console.log("No fault Btn Repair:", data);
        this.router.navigate(['/repairProcedures']);
      })
    }
  }
};
